<a class="ph-no-capture" [routerLink]="[$feature().URL]" (click)="trackCardClick()">
  <header>
    <svg-icon [src]="$feature().iconUrl" />
    <h2>{{ $feature().Name }}</h2>
  </header>
  <div [innerHtml]="$feature().Description"></div>
  <span>Open <svg-icon src="/assets/svg/arrow--right.svg" /></span>
</a>
